import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { StylePackData, StylePackItemTypes, templateLabels } from './style-packs-tab';
import StylePackItem from './style-pack-item';
import StylePackOptions from './style-pack-options';
import StylePackRequestBtn from './style-pack-request-btn';

export interface StylePacksInfoProps {
	stylePack?: StylePackData;
	selectedItem: string;
}

export interface InfoMap {
	[key: string]: string;
}

const backupStylePack: StylePackData = {
	id: 'backup',
	name: 'Miscellaneous',
	locked: false,
	stylePack: [],
};

export default function StylePackInfo(props: StylePacksInfoProps) {
	const {
		stylePack = backupStylePack,
		selectedItem = '',
	} = props;

	const {
		name,
		locked,
		stylePack: stylePackContent,
	} = stylePack;

	useEffect(() => {
		if (selectedItem) {
			setTimeout(() => {
				const item = document.getElementById(`style-pack-info-content-item-${selectedItem}`);
				if (item) {
					item.scrollIntoView({
						behavior: 'smooth',
						block: 'end',
						inline: 'nearest',
					});
				}
			}, 500);
		}
	}, [selectedItem]);

	const isMiscellaneous = useMemo(() => stylePack.id === 'miscellaneous', [stylePack]);

	return ((stylePack.id === 'backup' || !stylePack) ? <></> : (
		<div
			className={'style-pack-info'}
			data-testid="style-pack-info"
			style={{ paddingBottom: locked ? '72px' : '0' }}
		>
			<div className="style-pack-info-content" data-testid="style-pack-info-content">
				<StylePackOptions type={stylePack.id} />
				{stylePackContent.map((pack, index) => (
					<div key={`style-pack-info-${index}`}>
						{pack.templates.length > 0 && (
							<>
								<div
									className="style-pack-info-content-title"
									data-testid={`style-pack-info-content-title-${index}`}
									key={`style-pack-info-content-title-${index}`}
								>
									{templateLabels[pack.type]}
								</div>
								<div
									className={classNames('style-pack-info-content-items', { misc: isMiscellaneous })}
									data-testid={`style-pack-info-content-items-${index}`}
									key={`style-pack-info-content-items-${index}`}
								>
									{pack.templates.map((item, _index) => (
										<React.Fragment key={`style-pack-info-item-wrapper-${item.id}-${_index}`}>
											<StylePackItem
												key={`style-pack-info-item-${item.id}-${_index}`}
												item={item}
												type={StylePackItemTypes.Info}
											/>
											{isMiscellaneous && (
												<div className="misc-options-container" >
													<StylePackOptions
														key={`style-pack-info-option-${item.id}-${_index}`}
														type={item.type}
													/>
												</div>
											)}
										</React.Fragment>
									))}
								</div>
							</>
						)}
					</div>
				))}
				{!!locked && <StylePackRequestBtn stylePackName={name} existingMargin/>}
			</div>
		</div>
	));
}
